import { useEffect } from "react";
import cyclesOfLifeDark from "../assets/images/cycles-of-life-dark.svg";
import cyclesOfLifeLight from "../assets/images/cycles-of-life-light.svg";
import { useGlobalContext } from "../context/GlobalContext.jsx";
import {
  initializeWheel,
  cleanup,
} from "./helpers/CyclesOfLife/cycles-of-life.js";

const CyclesOfLife = ({ onExpand }) => {
  const { darkMode } = useGlobalContext();
  const cyclesOfLife = darkMode ? cyclesOfLifeDark : cyclesOfLifeLight;

  useEffect(() => {
    const timer = setTimeout(() => {
      initializeWheel("cyclesOfLife");
    }, 100);

    return () => {
      clearTimeout(timer);
      cleanup();
    };
  }, [darkMode]);

  return (
    <div
      className="w-full h-full flex items-center justify-center overflow-hidden rounded-2xl cursor-pointer relative"
      onClick={onExpand}
    >
      <div className="w-full h-full flex items-center justify-center relative z-10">
        <object
          id="cyclesOfLife"
          type="image/svg+xml"
          data={cyclesOfLife}
          className="max-w-xs max-h-full pointer-events-none"
        ></object>
      </div>
    </div>
  );
};

export default CyclesOfLife;
